// Generate the required CSS
// @ts-ignore
import iconFont from 'react-native-vector-icons/Fonts/MaterialCommunityIcons.ttf';
import {useEffect} from 'react';

export default function useReactNativeVectorIconInWeb() {
  useEffect(() => {
    const iconFontStyles = `@font-face {
    src: url(${iconFont});
    font-family: MaterialCommunityIcons;
  }`;
    const style = document.createElement('style');
    style.type = 'text/css';

    // Append the iconFontStyles to the stylesheet
    // @ts-ignore
    if (style.styleSheet) {
      // @ts-ignore
      style.styleSheet.cssText = iconFontStyles;
    } else {
      style.appendChild(document.createTextNode(iconFontStyles));
    }

    // Inject the stylesheet into the document head
    document.head.appendChild(style);
  }, []);
}
